export function deriveShowFeatureFlagsNav(
  pref: string | null | undefined,
  defaultValue: boolean
): boolean {
  return pref ? pref === "on" : defaultValue;
}
